import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { IntercomService } from '@app/core/services/intercom.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'adspt-disallowed-optimization-message',
  templateUrl: 'disallowed-optimization-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class DisallowedOptimizationMessageComponent {
  readonly is = inject(IntercomService);
}
